import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import logo from '../../assets/icon.svg';

export default function Logo() {
  return (
    <Box as={Link} to="/" display="flex" alignItems="center">
      <Box
        as="img"
        src={logo}
        alt="Logo"
        mr={3}
        height="45px"
        width="45px"
        objectFit="contain"
      />
      <Text fontWeight="400" fontSize="2xl">
        Navchitra
      </Text>
    </Box>
  );
}
